import { useEffect, useState } from "react";
import { collection, orderBy, query, getDocs } from "firebase/firestore";
import { db } from "../firebaseConfig.js";

const useAllApplications = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchApplications = async () => {
    setLoading(true);
    try {
      const appsQuery = query(
        collection(db, "apps"),
        orderBy("createdAt", "desc") 
      );

      const querySnapshot = await getDocs(appsQuery);
      const applicationsData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setApplications(applicationsData);
    } catch (err) {
      setError(err);
      console.error("Ошибка при получении заявок: ", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApplications();
  }, []);

  console.log(applications);

  return {
    applications,
    loading,
    error,
    refetchApplications: fetchApplications,
  };
};

export default useAllApplications;
